import { Env } from '@env';
import { useEffect, useRef } from 'react';

type Props = {
  onComplete: () => void;
};

export function OwnerOnboarding({ onComplete }: Props) {
  const onCompleteRef = useRef(onComplete);
  onCompleteRef.current = onComplete;

  useEffect(() => {
    let cancelled = false;
    let blobUrl: string | null = null;
    const iframe = document.createElement('iframe');
    iframe.title = 'Owner onboarding';
    iframe.style.position = 'fixed';
    iframe.style.inset = '0';
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.border = 'none';
    iframe.style.background = 'transparent';
    iframe.style.zIndex = '2147483000';
    document.body.appendChild(iframe);

    const onMessage = (event: MessageEvent) => {
      if (event.source !== iframe.contentWindow) return;
      if (typeof event.data !== 'string') return;

      try {
        const data = JSON.parse(event.data) as { type?: string };
        if (data.type === 'onboarding:complete') onCompleteRef.current();
      } catch {
        return;
      }
    };

    window.addEventListener('message', onMessage);

    const origin = Env.OWNER_ONBOARDING_URL;

    fetch(origin)
      .then((response) => response.text())
      .then((html) => {
        if (cancelled) return;

        const paramsModule = encodeURIComponent(
          'export const PARAMS={debug:false,steps:null,reveal:true};'
        );
        const importMap = JSON.stringify({
          imports: {
            [`${origin}src/params.js`]: `data:text/javascript;charset=utf-8,${paramsModule}`,
          },
        });

        const patchedHtml = html
          .replace('<link rel="modulepreload" href="./src/params.js" />', '')
          .replace(
            '<head>',
            `<head><base href="${origin}"><script>window.ReactNativeWebView={postMessage:function(message){parent.postMessage(message,"*")}};</script><script type="importmap">${importMap}</script>`
          );

        blobUrl = URL.createObjectURL(
          new Blob([patchedHtml], { type: 'text/html' })
        );
        iframe.src = blobUrl;
      });

    return () => {
      cancelled = true;
      window.removeEventListener('message', onMessage);
      iframe.remove();
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, []);

  return null;
}
